wbApp.factory('groupSvc', ['$resource', '$q', '$sce', '$translate', 'repositorySvc',
    function ($resource, $q, $sce, $translate, repositorySvc) {
        var Label = $resource('/Api/Groups/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Groups/GetAll' },
            'update': { method: 'POST', url: '/Api/Groups/Update' },
            'insert': { method: 'POST', url: '/Api/Groups/Insert' },
            'delete': { method: 'POST', url: '/Api/Groups/Delete' }
        });

        function createNew() {
            return {
                color: 16711680
            };
        }

        function getAllAsync(addNoLabel) {
            var result = [];
            var deferred = $q.defer();
            result.$promise = deferred.promise;
            result.$resolved = false;

            var colorUtils = new webooker_utils.ColorUtils();

            repositorySvc.customGet('getAll', Label).$promise.then(function (data) {
                angular.forEach(data, function (item) {
                    item.rgbColor = colorUtils.intToRgb(item.color);
                    item.htmlCaption = $sce.trustAsHtml('<i class="fa fa-square" aria-hidden="true" style="color: ' +
                        colorUtils.intToRgb(item.color) +
                        '"></i> ' + item.name);
                    result.push(item);
                });

                if (result.length > 0 && addNoLabel) {
                    result.push({
                        groupID: -1,
                        rgbColor:'red',
                        name: $translate.instant('TXT_WITHOUT_GROUP'),
                        htmlCaption: '<i class="fa fa-ban" style="color:red" aria-hidden="true"></i> ' + $translate.instant('TXT_WITHOUT_GROUP')
                    });
                }
                deferred.resolve(result);
                result.$resolved = true;
            }, function (errorResult) {
                deferred.reject(errorResult);
                result.$resolved = true;
            });

            return result;
        }

        function insert(data, successCallback, errorCallback, collection) {
            repositorySvc.insert(
                Label,                // $resource
                collection,               // collection
                data,                     // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback, collection) {
            repositorySvc.update(
                Label,            // $resource
                collection,            // collection
                data,                  // entity
                successCallback,
                errorCallback,
                'groupID');
        }

        function remove(data, successCallback, errorCallback, collection) {
            repositorySvc.remove(
                Label,                  // $resource
                collection,             // collection
                data,                   // entity
                successCallback,
                errorCallback, 
                null,
                'groupID');
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew
        }
    }]);